import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

function Feature({ illustration, number, title }) {
  const { t } = useTranslation()

  const renderIllustration = useCallback(() => {
    return (
      <div className="feature__illustration-inner-box">
        <motion.div
          animate={{
            y: [-5, 10, -5]
          }}
          className="feature__illustration-animation"
          transition={{
            duration: 3,
            ease: 'easeInOut',
            times: [0, 0.2, 0.5, 0.8, 1],
            repeat: Infinity,
            repeatDelay: 0
          }}
        >
          <img className="feature__illustration" src={illustration} alt="Game Overview Feature" />
        </motion.div>
      </div>
    )
  }, [illustration])

  return (
    <div className="feature">
      {number}
      <div className="feature__title">{t(title)}</div>
      <div className="feature__illustration-box">{renderIllustration()}</div>
    </div>
  )
}

Feature.propTypes = {
  illustration: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}

export default Feature
